import React from 'react'
import './index.scss'
import { ICONS } from '@Const/common'
import { Link, useLocation } from 'react-router'
import Navigation from '@App/navigation'

const Footer = () => {
    const location = useLocation()
    const currentYear = new Date().getFullYear()

    return (
        <footer className="footer-component" data-testid="footer-component">
            <div className="info">
                <Link to={Navigation.home.root()}>
                    <img src={ICONS.mlc_logo_black} alt="logo" />
                </Link>
                <span className="small">Mechanical Licensing Collective © {currentYear}</span>
            </div>
            <div className="links">
                <a href={Navigation.contactUs.root()} target="_blank" className="small" rel="noreferrer">
                    Need Help?
                </a>
                <a href="https://themlc.com/" target="_blank" className="small" rel="noreferrer">
                    The MLC Website
                </a>
                {location.pathname === Navigation.search.root() ? (
                    <a
                        className="small"
                        target="_blank"
                        href="https://www.themlc.com/musicalworksdatabasetermsuse"
                        rel="noreferrer"
                    >
                        Musical Works Database Terms of Use
                    </a>
                ) : (
                    <a
                        href="https://www.themlc.com/portaltermsofuse"
                        target="_blank"
                        className="small"
                        rel="noreferrer"
                    >
                        Portal Terms of Use
                    </a>
                )}
                <a href="https://www.themlc.com/privacy-policy" target="_blank" className="small" rel="noreferrer">
                    Privacy Policy
                </a>
            </div>
        </footer>
    )
}

export default Footer
